import { render, staticRenderFns } from "./LeadershipDashboardView.vue?vue&type=template&id=3a0be088&"
import script from "./LeadershipDashboardView.vue?vue&type=script&lang=ts&"
export * from "./LeadershipDashboardView.vue?vue&type=script&lang=ts&"
import style0 from "./LeadershipDashboardView.vue?vue&type=style&index=0&id=3a0be088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports